export class MenuConst {
  public static DASHBOARD = 1;
  public static USER = 2;
  public static PROFILE = 3;
  public static NOTIFICATION = 4;
  public static REGULASI = 5;
  public static FORMASI_KEPEGAWAIAN = 6;
  public static CUTI = 7;
  public static APPROVAL_CUTI = 8;
  public static KEHADIRAN = 9;
  public static RIWAYAT_PROFILE = 10;
  public static ALARM_PEGAWAI = 11;
}
